/* eslint-disable no-restricted-globals */

const workercode = () => {
  let timerInterval;
  let time = 0;
  let startTime = 0;
  const stopTimer = () => {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  };

  self.onmessage = function ({ data: { turn, initialTime = 0 } }) {
    if (turn === 'off') {
      stopTimer();
      return;
    }

    if (turn === 'reset') {
      stopTimer();
      time = 0;
      startTime = 0;
      self.postMessage({ time });
      return;
    }

    if (turn === 'on') {
      stopTimer();
      time = Number(initialTime) || 0;
      startTime = Date.now();
      self.postMessage({ time });
      timerInterval = setInterval(() => {
        time =
          (Number(initialTime) || 0) +
          Math.floor((Date.now() - startTime) / 1000);
        self.postMessage({ time });
      }, 250);
    }
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const blob = new Blob([code], { type: 'application/javascript' });
const worker_script = URL.createObjectURL(blob);
export default worker_script;
